import { Component } from '@angular/core';

@Component({
  selector: 'empathy-demographics-description',
  templateUrl: 'demographics-description.component.html',
  styleUrls: ['./demographics-description.component.scss']
})
export class DemographicsDescriptionComponent {}
